import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { blogTranslations } from '../translations/blogTranslations';

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = <T = string>(key: string, params?: Record<string, string>): T => {
    const currentTranslations = translations[language];
    const currentBlogTranslations = blogTranslations[language];
    
    // First try to get the direct (non-nested) translation
    let translation: any;
    
    // Check if it's a blog translation (starts with 'blog.')
    if (key.startsWith('blog.')) {
      if (!currentBlogTranslations) {
        console.warn(`No blog translations found for language: ${language}`);
        return key as unknown as T;
      }
      
      // Navigate the nested structure using reduce with proper type checking
      translation = key.split('.').reduce((obj: any, k) => {
        if (obj && typeof obj === 'object' && k in obj) {
          return obj[k];
        }
        return undefined;
      }, currentBlogTranslations);
    } else {
      // Try direct key lookup first
      translation = (currentTranslations as Record<string, any>)?.[key];
      
      // If direct lookup fails, try nested key resolution
      if (translation === undefined) {
        translation = key.split('.').reduce((obj: any, k) => {
          if (obj && typeof obj === 'object' && k in obj) {
            return obj[k];
          }
          return undefined;
        }, currentTranslations);
      }
    }

    if (translation === undefined) {
      // Only log warning in development
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Translation key not found: ${key}`);
      }
      return key as unknown as T;
    }

    // Handle interpolation
    if (params && typeof translation === 'string') {
      return Object.entries(params).reduce(
        (str, [key, value]) => str.replace(`{{${key}}}`, value),
        translation
      ) as unknown as T;
    }

    return translation as unknown as T;
  };

  return { t };
}; 